"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataOverlay = exports.WidgetStatusContainer = exports.SkeletonCatalogDashboardContainer = exports.NoDataContainer = exports.SkeletonProductStatusContainer = exports.StyledSkeletonWrapper = exports.SkeletonBreakdownContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const widget_1 = require("../../../components/widget");
exports.SkeletonBreakdownContainer = (0, styled_components_1.default)(widget_1.Widget) `
  padding: 0;  
  box-sizing: border-box;
  justify-content: center;

  .MuiSkeleton-root {
    background-color: ${ui_components_1.baseColors.background000};
    transform: none;
    animation: none;
  }

  .no-data-message {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    font-size: 1rem;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
exports.StyledSkeletonWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
exports.SkeletonProductStatusContainer = (0, styled_components_1.default)(widget_1.Widget) `
  padding: 0;  
  box-sizing: border-box;
  justify-content: center;
  align-items: center;

  .MuiSkeleton-root {
    background-color: ${ui_components_1.baseColors.background000};
    transform: none;
    animation: none;
  }

  .no-data-message {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    font-size: 1rem;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
exports.NoDataContainer = styled_components_1.default.div `
  position: absolute;

  .no-data-message {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    font-size: 1rem;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
exports.SkeletonCatalogDashboardContainer = (0, styled_components_1.default)(widget_1.Widget) `
  grid-area: product-catalog-widget;
  padding: 0;  
  box-sizing: border-box;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  flex-direction: row;

  .MuiSkeleton-root {
    background-color: ${ui_components_1.baseColors.background000};
    transform: none;
    animation: none;
  }

  .no-data-message {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    font-size: 1rem;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
exports.WidgetStatusContainer = styled_components_1.default.div `
  position: relative;
  display: inline-block;
  width: 100%;

  .blur-overlay {
    opacity: 0.5;
    pointer-events: none;
  }
`;
exports.NoDataOverlay = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .no-data-message {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    font-size: 1rem;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
